import { createSlice } from "@reduxjs/toolkit";
import {
  getNewsFeedData,
  updateNewsFeedData,
  NewsFeedLikes,
  NewsFeedDislikes,
} from "./actions";

const initialState = {
  newsFeed: [],
  newsPageNo: 1,
  newsPrevPage: 0,
  likeNewsFeed: null,
  dislikeNewsFeed: null,
};

const slice = createSlice({
  name: "news",
  initialState,
  reducers: {
    setNewsPageNo: (state, action) => {
      state.newsPageNo = action.payload;
    },
    setNewsPrevPage: (state, action) => {
      state.newsPrevPage = action.payload;
    },
    editNewsFeed: (state, action) => {
      state.newsFeed = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNewsFeedData.fulfilled, (state, action) => {
      if (action?.payload?.status === 200 && action?.payload?.data?.data) {
        state.newsFeed = action?.payload?.data?.data;
      }
    });
    builder.addCase(updateNewsFeedData.fulfilled, (state, action) => {
      if (action?.payload?.status === 200 && action?.payload?.data?.data) {
        state.newsFeed = state.newsFeed.concat(action?.payload?.data?.data);
      }
    });
    builder.addCase(NewsFeedLikes.fulfilled, (state, action) => {
      if (action?.payload?.status === 200 && action?.payload?.data?.data) {
        state.likeNewsFeed = action?.payload?.data?.data;
      }
    });
    builder.addCase(NewsFeedDislikes.fulfilled, (state, action) => {
      if (action?.payload?.status === 200 && action?.payload?.data?.data) {
        state.dislikeNewsFeed = action?.payload?.data?.data;
      }
    });
  },
});

export const { setNewsPageNo, setNewsPrevPage, editNewsFeed } = slice.actions;
export default slice.reducer;
